<template>
  <d-modal
    :class="{ 'is-hidden': isHidden }"
    size="lg"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ title }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="remote-job-form"
        tag="form"
        @keydown.enter.prevent>
        <d-row>
          <d-col cols="8">
            <div class="form-group">
              <label for="product_id">
                Wybierz wykonawcę
              </label>

              <validation-provider
                rules="required"
                name="worker_user_id"
                v-slot="{ errors }">
                <div :class="{
                  'form-control': true,
                  'is-select': true,
                  'is-invalid': errors.length
                }">
                  <v-select
                    placeholder="Wybierz wykonawcę"
                    :options="workers"
                    label="name"
                    :disabled="true"
                    v-model="worker_user_id"
                    :reduce="worker => worker.id" />
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col cols="4">
            <div class="form-group">
              <label for="planned_delivery_date">
                Sztuk do wykonania zdalnie:
              </label>

              <validation-provider
                :rules="'required|max_value:' + qty"
                name="quantity_to_execution"
                v-slot="{ errors }">
                <d-input-group
                  :append="'z ' + qty + ' szt.'"
                  :state="errors.length ? 'invalid' : null">
                  <d-input
                    type="number"
                    class="text-right"
                    :min="0"
                    :step="1"
                    :max="qty"
                    :disabled="true"
                    :state="errors.length ? 'invalid' : null"
                    v-model="quantity_to_execution" />
                </d-input-group>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>

        <hr />

        <d-row>
          <d-col cols="6">
            <div class="form-group">
              <label for="product_id">
                Wybierz przewoźnika (dostawa):
              </label>

              <validation-provider
                rules="required"
                name="delivery_driver_user_id"
                v-slot="{ errors }">
                <div :class="{
                  'form-control': true,
                  'is-select': true,
                  'is-invalid': errors.length
                }">
                  <v-select
                    placeholder="Wybierz przewoźnika"
                    :options="drivers"
                    label="name"
                    :disabled="isDelivered"
                    v-model="delivery_driver_user_id"
                    :reduce="driver => driver.id" />
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="delivery_before_order_process_id">
                Ustaw dostawę przed procesem:
              </label>

              <validation-provider
                rules="required"
                name="delivery_before_order_process_id"
                v-slot="{ errors }">
                <div :class="{
                  'form-control': true,
                  'is-select': true,
                  'is-invalid': errors.length
                }">
                  <v-select
                    key="delivery_before_order_process_id"
                    placeholder="Wybierz proces"
                    :options="procedureItems"
                    label="name"
                    :disabled="true"
                    v-model="delivery_before_order_process_id"
                    :reduce="process => process.id" />
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <d-checkbox
                inline
                toggle
                toggle-small
                v-model="delivery_block_process">
                Dostawa blokuje dalszy proces
              </d-checkbox>
            </div>

            <div class="form-group">
              <label for="planned_delivery_date">
                Planowana data dostawy:
              </label>

              <validation-provider
                rules="required"
                name="planned_delivery_date"
                v-slot="{ errors }">
                <div :class="{ 'is-invalid': errors.length }">
                  <d-datepicker
                    v-model="planned_delivery_date"
                    :monday-first="true"
                    format="yyyy-MM-dd"
                    placeholder="Wybierz datę"
                    :state="errors.length ? 'invalid' : null"
                    :language="polishTranslationForDatePicker" />
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>

          <d-col cols="6">
            <div class="form-group">
              <label for="product_id">
                Wybierz przewoźnika (odbiór):
              </label>

              <validation-provider
                rules="required"
                name="collection_driver_user_id"
                v-slot="{ errors }">
                <div :class="{
                  'form-control': true,
                  'is-select': true,
                  'is-invalid': errors.length
                }">
                  <v-select
                    placeholder="Wybierz przewoźnika"
                    :options="drivers"
                    label="name"
                    :disabled="isCollected"
                    v-model="collection_driver_user_id"
                    :reduce="driver => driver.id" />
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="delivery_before_order_process_id">
                Ustaw odbiór po procesie:
              </label>

              <validation-provider
                rules="required"
                name="collection_after_order_process_id"
                v-slot="{ errors }">
                <div :class="{
                  'form-control': true,
                  'is-select': true,
                  'is-invalid': errors.length
                }">
                  <v-select
                    key="collection_after_order_process_id"
                    placeholder="Wybierz proces"
                    :state="errors.length ? 'invalid' : null"
                    :options="procedureItems"
                    label="name"
                    :disabled="true"
                    v-model="collection_after_order_process_id"
                    :reduce="process => process.id" />
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <d-checkbox
                inline
                toggle
                toggle-small
                v-model="collection_block_process">
                Odbiór blokuje dalszy proces
              </d-checkbox>
            </div>

            <div class="form-group">
              <label for="planned_collection_date">
                Planowana data odbioru:
              </label>

              <validation-provider
                rules="required"
                name="planned_collection_date"
                v-slot="{ errors }">
                <div :class="{
                  'is-invalid': errors.length
                }">
                  <d-datepicker
                    v-model="planned_collection_date"
                    :monday-first="true"
                    format="yyyy-MM-dd"
                    placeholder="Wybierz datę"
                    :state="errors.length ? 'invalid' : null"
                    :language="polishTranslationForDatePicker" />
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>
      </validation-observer>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="saveInProgress"
        @click.prevent="cancel">
        Anuluj
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="saveInProgress"
        @click.prevent="validateForm">
        Zapisz zmiany
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../../utils/FormUtils.js';
import datepickerPolishTranslation from './../../../data/datepicker-translation-pl.js';

export default {
  name: 'remote-job-popup',
  props: [
    'drivers',
    'workers'
  ],
  computed: {
    polishTranslationForDatePicker () {
      return datepickerPolishTranslation;
    }
  },
  data () {
    return {
      // data
      order_id: 0,
      order_product_id: 0,
      delivery_driver_user_id: null,
      collection_driver_user_id: null,
      worker_user_id: null,
      quantity_to_execution: '',
      delivery_before_order_process_id: null,
      collection_after_order_process_id: null,
      delivery_block_process: false,
      collection_block_process: false,
      planned_delivery_date: null,
      planned_collection_date: null,
      // internal
      jobID: 0,
      isHidden: true,
      title: '',
      saveInProgress: false,
      qty: 0,
      procedureItems: [],
      isCollected: false,
      isDelivered: false
    };
  },
  mounted () {
    this.$bus.$on('remote-job-popup-show', this.openPopup);
  },
  methods: {
    openPopup (config) {
      this.order_id = config.order_id;
      this.order_product_id = config.order_product_id;
      this.order_process_id = config.order_process_id;
      this.order_process_item_id = config.order_process_item_id;
      this.procedureItems = config.procedure_items;
      this.qty = config.product_qty;

      if (!config.job_id) {
        this.title = 'Dodaj pracę zdalną';
        this.jobID = 0;
        this.delivery_driver_user_id = null;
        this.collection_driver_user_id = null;
        this.worker_user_id = config.worker_user_id;
        this.quantity_to_execution = config.qty;
        this.delivery_before_order_process_id = config.order_process_id;
        this.collection_after_order_process_id = config.order_process_id;
        this.delivery_block_process = false;
        this.collection_block_process = false;
        this.planned_delivery_date = new Date(config.delivery_date);
        this.planned_collection_date = new Date(config.collection_date);
      } else {
        this.title = 'Edytuj pracę zdalną';
        this.jobID = config.job_id;
        this.delivery_driver_user_id = config.delivery_driver_user_id;
        this.collection_driver_user_id = config.collection_driver_user_id;
        this.worker_user_id = config.worker_user_id;
        this.quantity_to_execution = config.quantity_to_execution;
        this.delivery_before_order_process_id = config.delivery_before_order_process_id;
        this.collection_after_order_process_id = config.collection_after_order_process_id;
        this.delivery_block_process = !!config.delivery_block_process;
        this.collection_block_process = !!config.collection_block_process;
        this.planned_delivery_date = new Date(config.planned_delivery_date);
        this.planned_collection_date = new Date(config.planned_collection_date);
        this.isCollected = !!config.collected_at;
        this.isDelivered = !!config.delivered_at;
      }

      setTimeout(() => {
        this.isHidden = false;
      }, 0);
    },
    handleClose () {
      this.isHidden = true;
    },
    validateForm () {
      FormUtils.validate(this.$refs['remote-job-form'], this.save);
    },
    save () {
      this.saveInProgress = true;
      let endpointURL = '/orders/remote-jobs/store';

      if (this.jobID) {
        endpointURL = '/orders/remote-jobs/update/' + this.jobID
      }

      FormUtils.submit(this, {
        endpoint: endpointURL,
        formData: {
          order_id: this.order_id,
          order_process_item_id: this.order_process_item_id,
          order_product_id: this.order_product_id,
          delivery_driver_user_id: this.delivery_driver_user_id,
          collection_driver_user_id: this.collection_driver_user_id,
          worker_user_id: this.worker_user_id,
          quantity_to_execution: parseInt(this.quantity_to_execution, 10),
          delivery_before_order_process_id: this.delivery_before_order_process_id,
          collection_after_order_process_id: this.collection_after_order_process_id,
          delivery_block_process: +this.delivery_block_process,
          collection_block_process: +this.collection_block_process,
          planned_delivery_date: [
            this.planned_delivery_date.getFullYear(),
            this.planned_delivery_date.getMonth() + 1,
            this.planned_delivery_date.getDate()
          ].map(n => n < 10 ? '0' + n : n).join('-'),
          planned_collection_date: [
            this.planned_collection_date.getFullYear(),
            this.planned_collection_date.getMonth() + 1,
            this.planned_collection_date.getDate()
          ].map(n => n < 10 ? '0' + n : n).join('-')
        },
        successTitle: this.jobID ? 'Zmodyfikowano pracę zdalną' : 'Zapisano pracę zdalną',
        successText: '',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapis nie powiódł się. Spróbuj ponownie.',
        beforeSuccessAction: () => {
          this.handleClose();
        },
        successAction: (response) => {
          this.saveInProgress = false;
          this.$bus.$emit('order-reload-remote-jobs');
          this.$bus.$emit('order-update-remote-job', {
            order_product_id: this.order_product_id,
            order_process_id: this.order_process_id,
            order_process_item_id: this.order_process_item_id,
            remote_job: response.item
          });
        },
        failAction: () => {
          this.saveInProgress = false;
          this.handleClose();
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  },
  beforeDestroy () {
    this.$bus.$off('remote-job-popup-show', this.openPopup);
  }
}
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
</style>
